import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Identity from "@/components/Identity";
import Heritage from "@/components/Heritage";
import Process from "@/components/Process";
import Spotlight from "@/components/Spotlight";
import WinesSection from "@/components/WinesSection";
import Shop from "@/components/Shop";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function Landing() {
  return (
    <div className="bg-[#070707] min-h-screen">
      <Nav />
      <Hero />
      <Identity />
      <Heritage />
      <Process />
      <Spotlight />
      <WinesSection />
      <Shop />
      <Contact />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <I18nProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0d0d0d",
                border: "1px solid rgba(197,165,114,0.4)",
                color: "white",
              },
            }}
          />
        </CartProvider>
      </I18nProvider>
    </AuthProvider>
  );
}

export default App;
